import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from '@amzn/storm-ui';
import { spinner } from '@amzn/storm-ui-icons';
import '@amzn/katal-components/styles.css';
import { MbmProvider } from "@amzn/react-arb-tools";
import { LocalizationContextBuilder, createAsyncMessageBundleManager } from "@amzn/arb-tools";
import { getChromeContext } from '@amzn/aac-chrome-internal-api';
import { App } from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import arbManifest from '../build/i18n/arbManifest';
import { AppWrapper } from './components/AppWrapper';
import { InterstitialPageMetricsPublisher } from './metrics';
import { NodeEnv } from 'src/constants';
import './logger';
import './index.scss';

const defaultLocale = 'en-US';

const myInterval = setInterval(getPageContainer, 100);

let rendered = false;
// If interstitial page doesn't get rendered within 10000ms, treat it as fail to render
setTimeout(() => {
  if (!rendered) {
    InterstitialPageMetricsPublisher.publishCounterMonitor('failure', 1);
  }
}, 10000);

function getPageContainer() {
  const container = document.getElementById("interstitial-page");
  // todo: add katal logger here
  if (container) {
    clearInterval(myInterval);
    init(container);
    rendered = true;
  }
}

const init = (container: any) => {
  const chromeContext = getChromeContext();
  const isMobile = chromeContext.getDeviceType() === 'mobile';
  const locale = chromeContext.getLocale()?.replace('_', '-') || defaultLocale;
  // The Suspense component causes React to display the fallback KatSpinner until
  // the i18n translation strings have been loaded.
  const localizationContextProvider = () => new LocalizationContextBuilder()
    .withLocale(locale)
    .build();
  const mbm = createAsyncMessageBundleManager({
    arbManifest,
    localizationContextProvider,
    urlPrefix: '/i18n',
    resolveBundleUrl: (url?: string) => {
      if (!url) {
        return undefined;
      }

      return process.env.NODE_ENV === NodeEnv.development
        ? `/i18n/${url}`
        : `https://dvr2obp51km68.cloudfront.net/i18n/${url}`;
    }
  });

  ReactDOM.render(
    <React.StrictMode>
      <AppInitWrapper>
        <React.Suspense fallback={<Icon type={spinner} size="lg"></Icon>}>
          <MbmProvider mbm={mbm}>
            <AppWrapper isMobile={isMobile}>
                <App />
            </AppWrapper>
          </MbmProvider>
        </React.Suspense>
      </AppInitWrapper>
    </React.StrictMode>,
    container
  );
}
